export const groupDictionary = {
  // Spanish UI -> Backend identifiers
  "Temáticas": "Temas",
  "Año de producción": "Years",
  "País": "Pais",
  "Secciones": "Secciones",
  "Ediciones AP": "EAP",
  "Ediciones Gira": "EGIRA",
  "Generación": "Generaciones",
  "Tipo de publicación": "Tipo",

  // English UI -> Backend identifiers
  "Themes": "Temas",
  "Production Year": "Years",
  "Country": "Pais",
  "Sections": "Secciones", 
  "AP Editions": "EAP",
  "Tour Editions": "EGIRA",
  "Generation": "Generaciones",
  "Publication Type": "Tipo"
};